/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Open_DashboardInputs */

const en_auth_login_open_dashboard = /** @type {(inputs: Auth_Login_Open_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open dashboard`)
};

/**
* | output |
* | --- |
* | "Open dashboard" |
*
* @param {Auth_Login_Open_DashboardInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_login_open_dashboard = /** @type {((inputs?: Auth_Login_Open_DashboardInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Open_DashboardInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_login_open_dashboard(inputs)
});